// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recentTransactions__buttons > button {
  margin-left: 10px;
  margin-right: 10px;
}

.iframe {
  /* height: webkit-fill-available !important; */
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/RecentTransactions.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd","sourcesContent":[".recentTransactions__buttons > button {\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.iframe {\r\n  /* height: webkit-fill-available !important; */\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
